export interface CompareItemSearchCriteria {
  compare_site: string;
  compare_url: string;
  compare_column: string;
  compare_pages: number;
  compare_range: string;
  include_shipping_fee: boolean;
  shop_site: string;
}

export interface CompareItemSearchCache {
  items: any[];
  manual_items: any[];
  criteria: CompareItemSearchCriteria | null;
  searched_at: string | null;
}

export const parseCompareItemSearchCache = (value: any): CompareItemSearchCache => {
  try {
    const parsed = typeof value === "string" ? JSON.parse(value) : value;

    if (Array.isArray(parsed)) {
      return { items: parsed, manual_items: [], criteria: null, searched_at: null };
    }

    return {
      items: Array.isArray(parsed?.items) ? parsed.items : [],
      manual_items: Array.isArray(parsed?.manual_items) ? parsed.manual_items : [],
      criteria: parsed?.criteria || null,
      searched_at: parsed?.searched_at || null,
    };
  } catch (error) {
    return { items: [], manual_items: [], criteria: null, searched_at: null };
  }
};

export const isSameCompareItemSearchCriteria = (
  left: CompareItemSearchCriteria,
  right: CompareItemSearchCriteria,
) =>
  left.compare_site === right.compare_site &&
  left.compare_url === right.compare_url &&
  left.compare_column === right.compare_column &&
  left.compare_pages === right.compare_pages &&
  left.compare_range === right.compare_range &&
  left.include_shipping_fee === right.include_shipping_fee &&
  left.shop_site === right.shop_site;

export const canDisplayStaleCompareItemSearch = (
  cached: CompareItemSearchCriteria,
  current: CompareItemSearchCriteria,
) =>
  cached.compare_site === current.compare_site &&
  cached.compare_url === current.compare_url &&
  cached.compare_column === current.compare_column &&
  cached.compare_range === current.compare_range &&
  cached.include_shipping_fee === current.include_shipping_fee &&
  cached.shop_site === current.shop_site;

export const mergeVisibleCompareItems = (
  searchItems: Array<Record<string, any>>,
  ...savedItemGroups: Array<Array<Record<string, any>>>
) => {
  const mergedItems = [...searchItems];
  const seenItemIds = new Set(searchItems.map((item) => String(item?.item_id ?? "")));

  const appendUniqueItems = (items: Array<Record<string, any>>) => {
    items.forEach((item) => {
      const itemId = String(item?.item_id ?? "");
      if (!itemId || seenItemIds.has(itemId)) {
        return;
      }

      seenItemIds.add(itemId);
      mergedItems.push(item);
    });
  };

  savedItemGroups.forEach(appendUniqueItems);

  return mergedItems;
};

export const placeDetailItemsLast = (items: Array<Record<string, any>>) => [
  ...items.filter((item) => item.item_price_source !== "detail"),
  ...items.filter((item) => item.item_price_source === "detail"),
];
